import React from "react";
import AmbassadorDashboard from "../Components/Ambassador/Dashboard/AmbassadorDashboard";

const AmbassadorDashboardPage: React.FC = () => <AmbassadorDashboard />;

export default AmbassadorDashboardPage;
